import Modal from './Modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeDialog, hideMessage } from '@codex/app-ducks/actions';
import withStyles from 'react-jss';
import styles from './styles';
var mapStateToProps = function (state) {
    return {
        isOpen: state.app.dialog.isDialogOpen,
        Component: state.app.dialog.Component,
        isMessageShown: state.app.message.isMessageShown
    };
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        closeDialog: closeDialog,
        hideMessage: hideMessage
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Modal));



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/index.tsx
// module id = 1336
// module chunks = 0